import { API_URL } from 'core/infra/environment'
import { HttpClient } from 'core/infra/http/HttpClient'

import { type EmptyLocation } from '../../domain/shipment/EmptyLocation'
import {
  type EmptyLocationPayload,
  ShipmentsRepository,
} from '../../infra/shipment/ShipmentsRepository'

export type SaveEmptyLocationFactoryDependencies = {
  shipmentsRepository: ShipmentsRepository
}

type EmptyLocationParams = EmptyLocationPayload & {
  exists: boolean
}

export function saveEmptyLocationFactory({
  shipmentsRepository,
}: SaveEmptyLocationFactoryDependencies) {
  return async function saveEmptyLocation(
    params: EmptyLocationParams,
    config?: {
      signal: AbortSignal
    }
  ): Promise<EmptyLocation> {
    const emptyLocation = {
      shipmentId: params.shipmentId,
      availabilityDate: params.availabilityDate,
      city: params.city,
      state: params.state,
    }
    return params.exists
      ? shipmentsRepository.updateEmptyLocation(emptyLocation, config)
      : shipmentsRepository.addEmptyLocation(emptyLocation, config)
  }
}

export function saveEmptyLocation(
  params: EmptyLocationParams,
  config?: {
    signal: AbortSignal
  }
): Promise<EmptyLocation> {
  const httpClient = new HttpClient(API_URL)
  const shipmentsRepository = new ShipmentsRepository({ httpClient })
  const save = saveEmptyLocationFactory({ shipmentsRepository })

  return save(params, config)
}
